import type { ReactNode } from "react";
import type { TrainingEvalRunSummaryView } from "@/api/trainingEval";
import { RightSidePanel } from "@/components/modal";
import { EvalRunDetailHeaderActions, EvalRunDetailNotice } from "./EvalRunDetailChrome";
import { EvalRunDetailView } from "./EvalRunDetailView";
import { evalRunDetailTitle } from "./evalRunFormat";
import { useEvalRunDetailController } from "./useEvalRunDetailController";

/**
 * eval run 상세 side panel 이다. 두 곳에서 쓴다:
 * - 결과 창의 표에서 여는 기본 상세. `EvaluationResultsWindowContent` 의 창 로컬 상태가 소유한다.
 * - 비교·병합 패널에서 run 을 눌렀을 때 화면을 바꾸지 않고 그 위에 겹치는 드릴다운. 비교 패널의
 *   로컬 상태가 소유한다.
 * 겹침 순서는 셸이 아니라 마운트 순서가 정한다. 나중에 열린 패널이 위에 있고, 아래 패널은
 * modalStack 이 잠근다(`RightSidePanel`).
 *
 * 마운트는 열림을 뜻한다. 호출부는 run id 를 key 로 준다. 그래서 다른 run 으로 바꾸면 콘텐츠
 * (로그 버퍼·주석 초안 등 내부 상태)를 새로 만든다. 닫으면 언마운트되어 상태를 버린다.
 */
export function EvalRunDetailPanel({
  run,
  onClose,
}: {
  run: TrainingEvalRunSummaryView;
  onClose: () => void;
}): ReactNode {
  const controller = useEvalRunDetailController(run, true);

  return (
    <RightSidePanel
      title={evalRunDetailTitle(run)}
      width={{ kind: "flex", percent: 60 }}
      headerActions={<EvalRunDetailHeaderActions controller={controller} />}
      onBackdrop={onClose}
      onRequestClose={onClose}
    >
      <EvalRunDetailNotice controller={controller} />
      <EvalRunDetailView controller={controller} />
    </RightSidePanel>
  );
}
